<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Balanza</h3>
        </b-col>
        <!-- <b-col class="text-right">
          <a href="#!" class="btn btn-sm btn-primary">See all</a>
        </b-col> -->
      </b-row>
    </template>

    <el-table class="table-responsive table"
               :data="ProductoUnico"
              header-row-class-name="thead-light">

      <el-table-column label="Producto"
                       min-width="260px"
                       prop="Producto">
         <template v-slot="{ row }">
         <div class="font-weight-600" style="color: #008B8B">{{Producto(row)}}</div>
        </template>
      </el-table-column>


      <el-table-column label="Viajes"
                       min-width="120px"
                       prop="Viajes">
          <template v-slot="{ row }">
         <div class="font-weight-500">{{ViajesBalanza(row)}}</div>
        </template>
      </el-table-column>

      <el-table-column label="Manifestado"
                       min-width="160px"  >
          <template v-slot="{ row }">
         <div class="font-weight-500">{{ManifestadoBalanza(row)}} TM</div>
        </template>
      </el-table-column>

      <el-table-column label="Descargado"
                       min-width="160px">
        <template v-slot="{ row }">
         <div class="font-weight-500">{{PnetoBalanza(row)}} TM</div>
        </template> 
           </el-table-column>

           
      <el-table-column label="Ingresado"
                       min-width="160px">
        <template v-slot="{ row }">
          <div class="font-weight-500"><b>{{PnetoAlmacen(row)}} TM</b></div>
        </template> 
           </el-table-column>

      <el-table-column label="Saldo"
          min-width="150px">
         <template v-slot="{ row }">
       <div class="font-weight-600" style="color:#F59221" v-if="(PnetoBalanza(row) - ManifestadoBalanza(row)) < 0">{{(PnetoBalanza(row) - ManifestadoBalanza(row) ).toFixed(3)}} TM</div>
      <div class="font-weight-600" style="color:#529E02" v-if="(PnetoBalanza(row) - ManifestadoBalanza(row)) >= 0">{{(PnetoBalanza(row) - ManifestadoBalanza(row) ).toFixed(3)}} TM</div>
        </template> 
      </el-table-column>

      <el-table-column min-width="230px" label="Progreso">
        <template v-slot="{row}">
          <div class="d-flex align-items-center">
            <span class="mr-2">{{calculateProgress(row)}}%</span>
            <base-progress
              :type="getProgressColor(row)"
              :value="calculateProgress(row)"
              class="custom-progress-bar"
            />

          </div>
        </template>
      </el-table-column>


    </el-table>
  </b-card>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  export default {

    props: {
    listaDatosData: {
      type: Array,
      default: () => [],
    },
    listaDatos: {
      type: Array,
      default: () => [],
    },
    listaDatosProducto: {
      type: Array,
      default: () => [],
    },
    listaConsignave: {
      type: Array,
      default: () => [],
    },
    listaClientesNave: {
      type: Array,
      default: () => [],
    },
    DataCompleta: {
      type: Array,
      default: () => [],
    },
  },
    name: 'page-visits-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
      }
    },
    created(){
     },
     computed:{
    
      mappedItems() {
  if (this.listaDatos && this.listaDatosProducto && this.listaConsignave && this.listaClientesNave) {
    return this.listaDatos.map((item) => {
      this.listaDatosProducto.forEach(product => {
        if (product.ID == item.PRODUCTO)
          item.PRODUCTO = product.PRODUCTO;
      });

      this.listaConsignave.forEach(productoxd => {
        if (productoxd.ID == item.ID_CONSIGNATARIO)
          item.CONSIGNAVE = productoxd.CONSIGNATARIO;
      });

      this.listaClientesNave.forEach(clientnave => {
        if (clientnave.ID == item.CONSIGNAVE)
          item.CONSIGNAVE = clientnave.CONSIGNATARIO;
      });

      return {
        BAGS: item.BAGS,
        BLS: item.BLS,
        CANTIDAD: this.convertir(item.CANTIDAD),
        PRODUCTO: item.PRODUCTO,
        ID: item.ID,
        Consignatario: item.CONSIGNAVE,
      };
    });
  } else {
    console.error('Al menos una de las listas es undefined. Lista de datos:', this.listaDatos, 'Lista de productos:',
     this.listaDatosProducto, 'Lista de consignatarios:', this.listaConsignave, 'Lista de clientes de nave:', this.listaClientesNave);
    return [];
  }
},


      ProductoUnico() {
      let producto = [  
      ...new Set(this.listaDatos.map(productlist => productlist.ID))
      ]
      return producto
      },


     },
     methods: {

     convertir(item){
     if(typeof(item)==="string")
     return parseFloat(item.replace(",", "."))

     if (typeof(item)==="number")
     return parseFloat(item.toString())
 

            },

        Producto(idproductophite) {
        let pnetoTotal = ''
        let res =  this.mappedItems.filter(val => {
        return val.ID == idproductophite;
        })

        res.forEach(element => {
        pnetoTotal += element.PRODUCTO
        });

      return pnetoTotal;

      },
      
      ViajesBalanza(idproductophite) {
      let res =  this.DataCompleta.filter(val => {
      return val.ID_PRODUCTO == idproductophite != 0;
      }).filter(function( element ) {
      return element.PESO_NETO_PUERTO !== 0;
      })
      return res.length;
    
      },

      ManifestadoBalanza(idproductophite) {
      let pnetoTotal = 0
      let res =  this.mappedItems.filter(val => {
      return val.ID == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.CANTIDAD
      });

      return pnetoTotal.toFixed(3);

      },

      PnetoBalanza(idproductophite) {
      let pnetoTotal = 0
      let res =  this.DataCompleta.filter(val => {
      return val.ID_PRODUCTO == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.PESO_NETO_PUERTO
      });

      return pnetoTotal.toFixed(3);

      },

      
      PnetoAlmacen(idproductophite) {
      let pnetoTotal = 0
      let res =  this.DataCompleta.filter(val => {
      return val.ID_PRODUCTO == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.PESO_NETO_ALMACEN
      });

      return pnetoTotal.toFixed(3);

      },

      calculateProgress(row) {
    const Pneto = this.PnetoBalanza(row);
    const Manifestado = this.ManifestadoBalanza(row);
    return parseFloat(((Pneto / Manifestado) * 100).toFixed(2));
  },

  getProgressColor(row) {
    const progress = this.calculateProgress(row);

    if (progress <= 30) {
      return 'orange';
    } else if (progress <= 97) {
      return 'yellow';
    } else {
      return 'green';
    }
  },

         }
         

  }
</script>
<style>

.custom-progress-bar.orange {
  background-color: #FF6800;
}

.custom-progress-bar.yellow {
  background-color: #FFAF1D;
}

.custom-progress-bar.green {
  background-color: #38c172;
}
.card .table td, .card .table th{
  padding-right:0.2rem;
}
</style>
